import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function NotificationsIcon(props: IconProps) {
    return <Icon {...props} iconKey={"notifications"}/>
}
